import { ChangeDetectorRef, Directive, ElementRef, HostListener, Injector, Optional } from '@angular/core';
import { FormGroupDirective, NgForm, NG_VALUE_ACCESSOR } from '@angular/forms';

import { ValueAccessor } from './value-accessor';

/* tslint:disable:directive-selector */
@Directive({
    selector: 'anj-input, anj-textarea',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: TextValueDirective,
            multi: true
        }
    ]
})
export class TextValueDirective extends ValueAccessor {
    constructor(@Optional() parentForm: NgForm,
                @Optional() parentFormGroup: FormGroupDirective,
                element: ElementRef,
                injector: Injector,
                changeRef: ChangeDetectorRef) {
        super(element, parentForm, parentFormGroup, injector, changeRef);
    }

    @HostListener('anjChange', ['$event.detail.value'])
    public onAnjChange(value: any) {
        this.onChangeEvent(value);
    }
}
